"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext, useState } from "react";
import CommonInput from "@/components/utils/input/CommonInput";
import type { ApiProfileProxy } from "@/generated/models/ApiProfileProxy";
import type { ApiProfileProxyAction } from "@/generated/models/ApiProfileProxyAction";
import { AuthContext } from "@/components/auth/Auth";
import { ReactQueryWrapperContext } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { useMutation } from "@tanstack/react-query";
import { commonApiPut } from "@/services/api/common-api";
import CircleLoader, { CircleLoaderSize } from "@/components/distribution-plan-tool/common/CircleLoader";
import type { ApiUpdateProxyActionRequest } from "@/generated/models/ApiUpdateProxyActionRequest";
export default function ProfileProxyCreditEdit(t0) {
  const $ = _c(43);
  const {
    profileProxy,
    profileProxyAction,
    setViewMode
  } = t0;
  const {
    requestAuth,
    setToast
  } = useContext(AuthContext);
  const {
    onProfileProxyModify
  } = useContext(ReactQueryWrapperContext);
  const [creditAmount, setCreditAmount] = useState(profileProxyAction.credit_amount ?? 0);
  const isChangedAndValid = profileProxyAction.credit_amount !== creditAmount && creditAmount > 0;
  const [submitting, setSubmitting] = useState(false);
  let t1;
  if ($[0] !== profileProxy || $[1] !== profileProxyAction.id) {
    t1 = async body => await commonApiPut({
      endpoint: `proxies/${profileProxy.id}/actions/${profileProxyAction.id}`,
      body
    });
    $[0] = profileProxy;
    $[1] = profileProxyAction.id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== onProfileProxyModify || $[4] !== profileProxy || $[5] !== setToast || $[6] !== setViewMode) {
    t2 = () => {
      onProfileProxyModify({
        profileProxyId: profileProxy.id
      });
      setToast({
        message: "Action credit updated successfully!",
        type: "success"
      });
      setViewMode();
    };
    $[3] = onProfileProxyModify;
    $[4] = profileProxy;
    $[5] = setToast;
    $[6] = setViewMode;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== setToast) {
    t3 = error => {
      setToast({
        message: error as unknown as string,
        type: "error"
      });
    };
    $[8] = setToast;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setSubmitting(false);
    };
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t1 || $[12] !== t2 || $[13] !== t3) {
    t5 = {
      mutationFn: t1,
      onSuccess: t2,
      onError: t3,
      onSettled: t4
    };
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const profileProxyActionCreditMutation = useMutation(t5);
  let t6;
  if ($[15] !== creditAmount || $[16] !== profileProxyActionCreditMutation || $[17] !== requestAuth) {
    t6 = async () => {
      setSubmitting(true);
      const {
        success
      } = await requestAuth();
      if (!success) {
        setSubmitting(false);
        return;
      }
      await profileProxyActionCreditMutation.mutateAsync({
        credit_amount: creditAmount
      });
    };
    $[15] = creditAmount;
    $[16] = profileProxyActionCreditMutation;
    $[17] = requestAuth;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  const onSubmit = t6;
  let t7;
  if ($[19] !== creditAmount) {
    t7 = creditAmount.toString();
    $[19] = creditAmount;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = newV => setCreditAmount(parseInt(newV ?? "0"));
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t7) {
    t9 = <div className="tw-w-full sm:tw-w-40"><CommonInput value={t7} inputType="number" onChange={t8} placeholder="Credit Amount" theme="light" size="sm" /></div>;
    $[22] = t7;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== setViewMode || $[25] !== submitting) {
    t10 = <button onClick={setViewMode} disabled={submitting} type="button" className="tw-w-full sm:tw-w-auto tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-flex tw-items-center tw-justify-center tw-rounded-lg tw-bg-iron-800 hover:tw-bg-iron-700 tw-border tw-border-solid tw-border-iron-700 tw-text-iron-300 hover:tw-text-iron-50 focus:tw-outline-none tw-transition tw-duration-300 tw-ease-out">Cancel</button>;
    $[24] = setViewMode;
    $[25] = submitting;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  const t11 = submitting || !isChangedAndValid;
  const t12 = `${isChangedAndValid ? "hover:tw-bg-primary-600 hover:tw-border-primary-600" : "tw-opacity-50"} tw-w-full tw-flex tw-items-center tw-justify-center tw-relative tw-bg-primary-500 tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-text-white tw-border tw-border-solid tw-border-primary-500 tw-rounded-lg tw-transition tw-duration-300 tw-ease-out`;
  let t13;
  if ($[27] !== submitting) {
    t13 = submitting && <CircleLoader size={CircleLoaderSize.SMALL} />;
    $[27] = submitting;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <span>Update</span>;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t13) {
    t15 = <div className="tw-flex tw-items-center tw-space-x-2">{t13}{t14}</div>;
    $[30] = t13;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== onSubmit || $[33] !== t11 || $[34] !== t12 || $[35] !== t15) {
    t16 = <button onClick={onSubmit} disabled={t11} type="button" className={t12}>{t15}</button>;
    $[32] = onSubmit;
    $[33] = t11;
    $[34] = t12;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t10 || $[38] !== t16) {
    t17 = <div className="tw-mt-4 sm:tw-mt-0 tw-flex tw-items-center tw-justify-end sm:tw-justify-start tw-gap-x-3">{t10}{t16}</div>;
    $[37] = t10;
    $[38] = t16;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== t17 || $[41] !== t9) {
    t18 = <div className="tw-h-full tw-py-3 xl:tw-h-14 tw-rounded-lg tw-bg-iron-900 tw-ring-1 tw-ring-inset tw-ring-iron-600"><div className="tw-h-full lg:tw-flex tw-items-center tw-px-3 tw-gap-x-3"><div className="tw-flex tw-flex-col sm:tw-flex-row sm:tw-items-center tw-justify-between tw-w-full tw-gap-x-3">{t9}{t17}</div></div></div>;
    $[40] = t17;
    $[41] = t9;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  return t18;
}